import { render, staticRenderFns } from "./crudBudget.vue?vue&type=template&id=2a3146aa&scoped=true&"
import script from "./crudBudget.vue?vue&type=script&lang=js&"
export * from "./crudBudget.vue?vue&type=script&lang=js&"
import style0 from "./crudBudget.vue?vue&type=style&index=0&id=2a3146aa&prod&lang=css&"
import style1 from "./crudBudget.vue?vue&type=style&index=1&id=2a3146aa&prod&scoped=true&lang=css&"
import style2 from "./crudBudget.vue?vue&type=style&index=2&id=2a3146aa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3146aa",
  null
  
)

export default component.exports